module.exports = __webpack_public_path__ + "media/images/responsive/articles/button_diamond-fdb68243f868f1691ca94f252fb5ba93.svg";